import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppComponent } from './app.component';
import { IndexComponent } from './pages/index/index.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { MessageDialogComponent } from './dialogs/message-dialog/message-dialog.component';
import { wrapperGetSiteLanguage } from './javascript.js';
import { EditComponent } from './pages/edit/edit.component';
import { ParameterHashLocationStrategy } from './utils/routingStrategy';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { FolderComponent } from './pages/folder/folder.component';
import { DeleteDialogComponent } from './dialogs/delete-dialog/delete-dialog.component';
import { HelpItemComponent } from './pages/help-item/help-item.component';
import { LoginComponent } from './pages/login/login.component';
import { RedirectComponent } from './pages/redirect/redirect.component';
import { PageComponent } from './pages/page/page.component';
import { TextInputDialogComponent } from './dialogs/text-input-dialog/text-input-dialog.component';
import { SelectimageComponent } from './dialogs/selectimage/selectimage.component';
import { SignaturedialogComponent } from './dialogs/signaturedialog/signaturedialog.component';
import { DropboxStartComponent } from './pages/dropbox-start/dropbox-start.component';
import { DropboxWelcomeComponent } from './pages/dropbox-welcome/dropbox-welcome.component';
import { RedirectGoogledriveComponent } from './pages/redirect-googledrive/redirect-googledrive.component';
import { RedirectOauthComponent } from './pages/redirect-oauth/redirect-oauth.component';
import { RedirectDropboxComponent } from './pages/redirect-dropbox/redirect-dropbox.component';
import { RedirectCloudboxComponent } from './pages/redirect-cloudbox/redirect-cloudbox.component';
import { CanvasEditorComponent } from './components/canvas-editor.component';
import { CheckboxComponent } from './components/checkbox.component';
import { EraserComponent } from './components/eraser.component';
import { PenMarkerComponent } from './components/pen-marker.component';
import { SavetogdriveComponent } from './components/savetogdrive.component';
import { SelectCropPointsComponent } from './components/select-crop-points.component';
import { SelectPointComponent } from './components/select-point.component';
import { SignatureComponent } from './components/signature.component';
import { TextComponent } from './components/text.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ScanWritrHttpInterceptor } from './utils/scanwritrHttpInterceptor';
import { PrintComponent } from './pages/print/print.component';

const routes: Routes = [
  { path: 'gallery', component: IndexComponent },
  { path: 'gallery/:document', component: FolderComponent },
  { path: 'gallery/:document/:swrp', component: PageComponent },
  { path: 'gallery', component: IndexComponent },
  { path: 'edit/:clientId/:token/:serverId', component: EditComponent },
  { path: 'edit/:clientId/:token', component: EditComponent },
  { path: 'login', component: LoginComponent },
  { path: 'help', component: HelpItemComponent },
  { path: 'redirect/cloudbox/fetchfile/:fileid/:filename/:fileextension/:token', component: RedirectCloudboxComponent },
  { path: 'redirect/googledrive/login/:code/:state', component: RedirectGoogledriveComponent },
  { path: 'redirect/dropbox/:action/:param1/:param2', component: RedirectDropboxComponent },
  { path: 'redirect/dropbox/:action/:param1', component: RedirectDropboxComponent },
  { path: 'redirect/dropbox/:action', component: RedirectDropboxComponent },
  { path: 'redirect/:oauthprovider/login/:param1/:param2', component: RedirectOauthComponent },
  { path: 'redirect/:oauthprovider/login/:param1', component: RedirectOauthComponent },
  { path: 'redirect', component: RedirectComponent },
  { path: 'dropbox/welcome', component: DropboxWelcomeComponent },
  { path: 'dropbox/start', component: DropboxStartComponent },
  { path: 'print/preview', component: PrintComponent },
  { path: '**', component: IndexComponent },
  { path: '', pathMatch: 'full', redirectTo: 'index', data: { skipRouteLocalization: true } }
];

@NgModule({
  declarations: [
    AppComponent,
    IndexComponent,
    SafeHtmlPipe,
    MessageDialogComponent,
    EditComponent,
    FolderComponent,
    DeleteDialogComponent,
    HelpItemComponent,
    LoginComponent,
    RedirectComponent,
    PageComponent,
    TextInputDialogComponent,
    SelectimageComponent,
    SignaturedialogComponent,
    DropboxStartComponent,
    DropboxWelcomeComponent,
    RedirectGoogledriveComponent,
    RedirectOauthComponent,
    RedirectDropboxComponent,
    RedirectCloudboxComponent,
    CanvasEditorComponent,
    CheckboxComponent,
    EraserComponent,
    PenMarkerComponent,
    SavetogdriveComponent,
    SelectCropPointsComponent,
    SelectPointComponent,
    SignatureComponent,
    TextComponent,
    PrintComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient]
      },
      defaultLanguage: wrapperGetSiteLanguage()
    }),
    RouterModule.forRoot(routes),
    NgbModule
  ],
  exports: [RouterModule],
  providers: [{ provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: APP_INITIALIZER,
      useFactory: loadTranslations, deps: [TranslateService], multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ScanWritrHttpInterceptor, multi: true
    },
    {
      provide: LocationStrategy,
      useClass: ParameterHashLocationStrategy
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

// required for AOT compilation
export function httpLoaderFactory(http: HttpClient) {
  const randomNr = Math.floor(Math.random() * 1000)
  return new TranslateHttpLoader(http, './assets/i18n/', `.json?rnd=${randomNr}`);
}
export function loadTranslations(translateService: TranslateService) {
  console.log('translate test');
  return () => translateService.use(wrapperGetSiteLanguage()).toPromise();
}
